import Vue from 'vue'
import router from '@/router'

const DEFAULT_ERROR_MESSAGE = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
const SESSION_EXPIRED_MESSAGE =
  'Session หมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง'

function clearAuthCookies() {
  Vue.prototype.$cookies.remove('token')
  Vue.prototype.$cookies.remove('sc')
  Vue.prototype.$cookies.remove('bc')
  Vue.prototype.$cookies.remove('isinno')
}

function redirectToLogin(slug) {
  const campaign =
    slug ||
    router.currentRoute.params?.slug ||
    localStorage.getItem('slug') ||
    ''

  localStorage.setItem('redirectPage', router.currentRoute.fullPath)

  router.push({ name: 'Login', query: { campaign } }).catch(() => {})
}

export function useAxiosErrorHandler() {
  function handleError(error, { slug } = {}) {
    const status = error?.response?.status
    const responseMessage =
      error?.response?.data?.message || error?.response?.data?.error

    if (status === 401) {
      Vue.$toast.error(SESSION_EXPIRED_MESSAGE, {
        duration: 5000,
        position: 'top',
      })
      clearAuthCookies()
      redirectToLogin(slug)
      return SESSION_EXPIRED_MESSAGE
    }

    const message = responseMessage || DEFAULT_ERROR_MESSAGE

    Vue.$toast.error(message, {
      duration: 5000,
      position: 'top',
    })

    return message
  }

  return { handleError }
}
